import { TextField } from "@mui/material";
import { FormikHandlers } from "formik";
import FieldRow from "./FieldRow";

const DEFAULT_DESCRIPTION =
  "Customer replies to platform email notifications will be sent to this email. The organization admin can update this later in Settings.";

interface ReplyEmailFieldProps {
  value: string;
  onChange: FormikHandlers["handleChange"];
  onBlur: FormikHandlers["handleBlur"];
  error?: boolean;
  helperText?: string | false;
  description?: string;
}

// The "Customer Reply Email" label + description + text field, shared by the
// Add/Edit Organization forms (ESR-1599) and the Settings screen's Reply
// Email tab (ESR-1616) - same field, same layout, just different Formik
// bindings and (on the Settings tab, which is already under Settings) a
// shorter description.
const ReplyEmailField = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  description = DEFAULT_DESCRIPTION,
}: ReplyEmailFieldProps) => (
  <FieldRow label="Customer Reply Email" description={description}>
    <TextField
      id="replyToEmail"
      placeholder="name@organization.com"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      fullWidth
    />
  </FieldRow>
);

export default ReplyEmailField;
